import { useStyletron } from 'baseui';
import { useSetAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import type { DrawerProps } from '../../side-panel/atoms/drawer.atom';
import { drawerAtom } from '../../side-panel/atoms/drawer.atom';
export const useRemainingItemsDrawer = ({
  remainingItemsDrawerProps
}: {
  remainingItemsDrawerProps?: Omit<DrawerProps, 'onClose'>;
}) => {
  const setDrawer = useSetAtom(drawerAtom);
  const [, theme] = useStyletron();
  const onClose = () => {
    setDrawer(RESET);
  };
  const openRemainingItemsDrawer = () => {
    if (!remainingItemsDrawerProps) {
      return;
    }
    setDrawer({
      ...remainingItemsDrawerProps,
      showDivider: true,
      styles: {
        containerStyles: {
          padding: '0',
          paddingTop: theme.sizing.scale200
        },
        contentContainerStyles: {
          paddingTop: '0'
        },
        sideDrawerStyles: {
          borderTop: 'none',
          borderLeft: `${theme.sizing.scale0} solid ${theme.colors.borderOpaque}`
        }
      },
      onClose: onClose
    });
  };
  const closeRemainingItemDrawer = () => {
    onClose();
  };
  return {
    openRemainingItemsDrawer,
    closeRemainingItemDrawer
  };
};